export const initGA = (user_id, user_email) => {
    if (process.env.REACT_APP_IS_TRACKING_REQUIRED === 'false') return;

    // Load the gtag.js script
    const script = document.createElement('script');
    script.setAttribute('async', '');
    script.src = `https://www.googletagmanager.com/gtag/js?id=${process.env.REACT_APP_GOOGLE_TRACKING_ID}`;
    document.head.appendChild(script);

    // Initialize gtag
    window.dataLayer = window.dataLayer || [];
    function gtag() {
        window.dataLayer.push(arguments);
    }
    window.gtag = gtag;

    gtag('js', new Date());

    // Prevent automatic page_view so we can handle it manually
    gtag('config', `${process.env.REACT_APP_GOOGLE_TRACKING_ID}`, { send_page_view: false, app_user_id: user_id, app_user_email: user_email });
};
